/**
 * Default backend base URL used when `VITE_API_URL` is not set at build
 * time. Prod builds on Cloudflare Pages bake `VITE_API_URL` from the env;
 * this constant is the single source of truth for the fallback.
 *
 * To point the iframe at a different backend (staging, per-operator,
 * local), set `VITE_API_URL` in `.env` or in the deployment environment
 * — do not edit this constant per-environment.
 */
export const DEFAULT_API_URL = 'https://api.getcardbase.com';

/** Customer support inbox surfaced from "Ask a Question" CTAs. */
export const SUPPORT_EMAIL = 'support@repackz.fun';

// TODO(confirm URL): external Terms of Service link referenced by the refund /
// partial-redemption notice. Placeholder until the real ToS URL is provided.
export const TERMS_OF_SERVICE_URL = '';

/**
 * Help / FAQ site behind the `HelpLink` control (pack page + My Packs
 * header). One URL for the whole deploy: the control stays hidden until an
 * operator switches it on in the Design Constructor, so nobody gets a
 * support site that isn't theirs by accident. A deploy that serves a
 * different partner overrides it with `VITE_SUPPORT_URL` at build time.
 */
export const SUPPORT_URL =
  import.meta.env.VITE_SUPPORT_URL ?? 'https://repackz.support.site/';

/**
 * The public provably-fair checker (apps/verify). Verify links a receipt there
 * as `?ticket=<id>`; a staging deploy points it at its own checker with
 * `VITE_VERIFY_URL`.
 */
export const VERIFY_URL = (import.meta.env.VITE_VERIFY_URL ?? 'https://verify.repackz.fun').replace(/\/+$/, '');

export const config = {
  apiUrl: import.meta.env.VITE_API_URL ?? DEFAULT_API_URL,
  devConsole: import.meta.env.VITE_DEV_CONSOLE === 'true' || import.meta.env.DEV,
  stripePublishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ?? '',
} as const;
